<template>
                <div class="news-items mt54">
                    
                    <a href="https://m.chinanews.com/wap/detail/chs/zw/hm62c9414f7421ae501381a4fe.shtml" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1661418808691317.jpg" alt="澳门青年代表陈祥受邀参加2022中国数字经济创新发展大会，展现澳门数字新声" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/09<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">澳门青年代表陈祥受邀参加2022中国数字经济创新发展大会，展现澳门数字新声</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://appimg.modaily.cn/app/szb/pc/content/202205/24/content_194692.html" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1655962814758533.jpg" alt="“星火·链网”打造国家级数字经济枢纽" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/23<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">“星火·链网”打造国家级数字经济枢纽</div>
                                <div class="desc">据中国信息通信研究院工业互联网与物联网所武汉运营中心主任谭敏介绍，“‘星火·链网’在智慧城市、数字政务、供应链金融、能源资料等领域已有较好的应用基础，更好地驱动光谷优势产业数字化，培育数字经济新业态。”</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/61" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1654400902446995.jpg" alt="澳门智慧人文励政会拜访经济财政司 交流数字产业发展" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/25<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">澳门智慧人文励政会拜访经济财政司 交流数字产业发展</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/60" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1654400842775676.png" alt="“星火·链网”赋能粤桂茶叶数字发展，“星农计划”助力乡村振兴" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/23<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">“星火·链网”赋能粤桂茶叶数字发展，“星农计划”助力乡村振兴</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/59" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1654400766209834.jpg" alt="“星火·链网”赋能粤桂茶叶数字发展，“星农计划”助力乡村振兴" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/22<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">“星火·链网”赋能粤桂茶叶数字发展，“星农计划”助力乡村振兴</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/58" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="/core/extend/kindeditor/attached/image/20220605/20220605034159_94111.jpg" alt="澳门数字新经济论坛成功举办 助力未来数字产业高质量发展" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/12<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">澳门数字新经济论坛成功举办 助力未来数字产业高质量发展</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/o96HmV7mNV1OpZOgqLNSjg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1654400279909918.jpg" alt="湾区青年说丨粤港澳三地青年畅谈湾区故事" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/06<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">湾区青年说丨粤港澳三地青年畅谈湾区故事</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/56" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="/core/extend/kindeditor/attached/image/20220605/20220605033537_46481.jpg" alt="澳獲辦寶船國際茶文化節" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">04/27<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">澳獲辦寶船國際茶文化節</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>